import {Pie} from "react-chartjs-2";
import {Chart as ChartJS, ArcElement, Tooltip, Legend} from 'chart.js';
import {useEffect} from "react";


ChartJS.register(ArcElement, Tooltip, Legend);


export default function SentenceCefr({className, data, sentence, ...props}) {

    function chartConfig() {
        if (!data) return null;
        const labels = Object.keys(data)
        const datasets = [
            {
                label: 'word count',
                data: labels.map(label => data[label].count),
                backgroundColor: labels.map(label => data[label].color),
                borderColor: labels.map(label => data[label].color),
                borderWidth: 1,

            }
        ]
        return {
            labels: labels,
            datasets: datasets
        }

    }

    useEffect(() => {
            // reloadChart
            ChartJS.register(ArcElement, Tooltip, Legend);
    }, [data]);

    if (!data) return null;



    return (
        <div
            className={`w-full flex   rounded-xl p-4 flex-col  justify-center items-center  text-white  ${className}`}>
            <div className={"max-w-[80%]"}>
                <Pie data={chartConfig()}/>

            </div>
            <div className={"w-full mt-3 "}>
                <p className={"text-black"}>
                    {
                        sentence?.map((word, index) => {
                            return (
                                <span
                                    title={word?.level}
                                    className={"cursor-pointer hover:underline"}
                                    key={index}
                                      style={{color: word?.color}}>
                                        {word?.word}{' '}
                                    </span>
                            )
                        })
                    }
                </p>
            </div>
        </div>

    )
}